import ApiService from '@/common/api.service'

export default {
  namespaced: true,
  state: {
    student: null,
    notices: null,
    totalNotices: null,
  },
  getters: {
    student: state => state.student,
    notices: state => state.notices ?? [],
    totalNotices: state => state.totalNotices ?? 0,
  },
  mutations: {
    setStudent(state, data) {
      state.student = data
      state.notices = null
      state.totalNotices = null
    },
    setNotices(state, data) {
      state.notices = data
    },
    setNoticesTotal(state, data) {
      state.totalNotices = data
    },
    clearStudents(state) {
      state.student = null
    },
    setStatus(state, status) {
      if (!state.student) return
      state.student.status = status
    },
  },
  actions: {
    getStudent({ commit, state }, { id }) {
      return new Promise((resolve, reject) => {
        if (state.student && state.student?.id == id) return resolve(state.student)
        ApiService.get('sms/students', id)
          .then(({ data }) => {
            commit('setStudent', data)
            resolve(data)
          })
          .catch(reject)
      })
    },
    getNotices({ commit }, { id }) {
      return new Promise((resolve, reject) => {
        ApiService.query(`sms/students/${id}/notices`)
          .then(({ data }) => {
            commit('setNotices', data.notices)
            commit('setNoticesTotal', data.notices_count)
            resolve(data)
          })
          .catch(reject)
      })
    },
  },
}
